<template>
    <v-layout
        v-if="table.content.pagination.pages > 1"
        mt-5
        align-center
        wrap
        :class="{

            'px-3': $vuetify.breakpoint.xs,
            'justify-center': $vuetify.breakpoint.smAndDown,
            'justify-space-between': $vuetify.breakpoint.mdAndUp
        }"
    >
        <v-flex md5 sm7 xs12>
            <v-pagination
                v-model="pagination"
                :length="table.content.pagination.pages"
                :total-visible="7"
                prev-icon="arrow_back_ios"
                next-icon="arrow_forward_ios"
            />
        </v-flex>
        <v-flex md4 sm6 :class="{'mt-4': $vuetify.breakpoint.smAndDown}">
            <v-select
                :items="$vuetify.breakpoint.mdAndUp
                    ? [
                        { label: $t('Показывать по 10'), value: 10 },
                        { label: $t('Показывать по 25'), value: 25 },
                        { label: $t('Показывать по 50'), value: 50 },
                        { label: $t('Показывать по 100'), value: 100 }
                    ]
                    : [
                        { label: $t('Показывать по 10'), value: 10 },
                        { label: $t('Показывать по 25'), value: 25 },
                        { label: $t('Показывать по 50'), value: 50 },
                ]"
                solo
                :value="table.content.pagination.rowsPerPage"
                item-value="value"
                item-text="label"
                append-icon=""
                :label="$t('Показывать по 10')"
                class="input"
                @change="show_number($event)"
            >
              <template #append>
                <v-icon aria-hidden="true" translate="no">
                  expand_more
                </v-icon>
              </template>
            </v-select>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  props: {
    table: {
      type: Object,
    },
    request: {
      type: Object,
    },
  },
  methods: {
    ...mapMutations('employee_study/directorate', [
      'SET_DIRECTORATE_PAGE',
      'SHOW_DIRECTORATE_NUMBER',
    ]),
    ...mapMutations('employee_study/organizations', [
      'SET_ORG_PAGE',
      'SHOW_ORG_NUMBER',
    ]),
    ...mapActions('employee_study/organizations', [
      'change_organization_per_page',
    ]),
    ...mapMutations('employee_study/users', [
      'SET_USERS_PAGE',
      'SHOW_USERS_NUMBER',
    ]),
    ...mapActions('employee_study/users', [
      'change_user_per_page',
    ]),
    ...mapMutations('employee_study/courses', [
      'SET_COURSES_PAGE',
    ]),
    ...mapActions('employee_study/courses', [
      'change_course_per_page',
    ]),
    ...mapMutations('employee_study/coursesSummary', [
      'SET_COURSES_SUMMARY_PAGE',
    ]),
    ...mapActions('employee_study/coursesSummary', [
      'change_courses_summaries_per_page',
    ]),
    ...mapMutations('employee_study/coursesBusinessPlusSummary', [
      'SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE',
    ]),
    ...mapActions('employee_study/coursesBusinessPlusSummary', [
      'change_courses_business_plus_summaries_per_page',
    ]),
    ...mapMutations('employee_study/coursesVerification', [
      'SET_COURSES_VERIFICATION_PAGE',
    ]),
    ...mapActions('employee_study/coursesVerification', [
      'change_courses_verification_per_page',
    ]),
    ...mapActions('employee_study', [
      'get_users',
      'get_companies',
      'get_courses',
      'get_courses_summary',
      'get_courses_business_plus_summary',
      'get_courses_verification',
    ]),
    async show_number(event) {
      if (this.tab === 'directorate') {
        this.SHOW_DIRECTORATE_NUMBER(event);
      } else if (this.tab === 'organizations') {
        await this.change_organization_per_page(event);
        return this.get_companies({
          filter: {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy || null,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
          page      : this.table.content.pagination.page,
          perPage   : this.table.content.pagination.rowsPerPage,
          makeExport: false,
        });
      } else if (this.tab === 'users') {
        await this.change_user_per_page(event);
        return this.get_users({
          filter: {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy || null,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
          page      : this.table.content.pagination.page,
          perPage   : this.table.content.pagination.rowsPerPage,
          makeExport: false,
        });
      } else if (this.tab === 'courses') {
        await this.change_course_per_page(event);
      } else if (this.tab === 'courses_summary') {
        await this.change_courses_summaries_per_page(event);
        return this.get_courses_summary({
          filter: {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy || null,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
          page         : this.table.content.pagination.page,
          perPage      : this.table.content.pagination.rowsPerPage,
          business_plus: this.table.content.business_plus,
          makeExport   : false,
        });
      } else if (this.tab === 'courses_business_plus_summary') {
        await this.change_courses_business_plus_summaries_per_page(event);
        return this.get_courses_business_plus_summary({
          filter: {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy || null,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
          page      : this.table.content.pagination.page,
          perPage   : this.table.content.pagination.rowsPerPage,
          makeExport: false,
          business_plus: this.table.content.business_plus,
        });
      } else if (this.tab === 'courses_verification') {
        await this.change_courses_verification_per_page(event);
        return this.get_courses_verification({
          filter: {
            ...this.request,
            sort_name     : this.table.content.pagination.sortBy || null,
            sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
          },
          page      : this.table.content.pagination.page,
          perPage   : this.table.content.pagination.rowsPerPage,
          makeExport: false,
        });
      }
    },
  },
  computed: {
    ...mapGetters('employee_study', [
      'tab',
    ]),
    pagination: {
      get() {
        return this.table.content.pagination.page;
      },
      set($event) {
        if (this.tab === 'directorate') {
          return this.SET_DIRECTORATE_PAGE($event);
        } else if (this.tab === 'organizations') {
          this.SET_ORG_PAGE($event);
          return this.get_companies({
            filter: {
              ...this.request,
              sort_name     : this.table.content.pagination.sortBy || null,
              sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
            },
            page      : this.table.content.pagination.page,
            perPage   : this.table.content.pagination.rowsPerPage,
            makeExport: false,
          });
        } else if (this.tab === 'users') {
          this.SET_USERS_PAGE($event);
          return this.get_users({
            filter: {
              ...this.request,
              sort_name     : this.table.content.pagination.sortBy || null,
              sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
            },
            page      : this.table.content.pagination.page,
            perPage   : this.table.content.pagination.rowsPerPage,
            makeExport: false,
          });
        } else if (this.tab === 'courses') {
          return this.SET_COURSES_PAGE($event);
        } else if (this.tab === 'courses_summary') {
          this.SET_COURSES_SUMMARY_PAGE($event);
          return this.get_courses_summary({
            filter: {
              ...this.request,
              sort_name     : this.table.content.pagination.sortBy || null,
              sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
            },
            page      : this.table.content.pagination.page,
            perPage   : this.table.content.pagination.rowsPerPage,
            makeExport: false,
            business_plus: this.table.content.business_plus,
          });
        } else if (this.tab === 'courses_business_plus_summary') {
          this.SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE($event);
          return this.get_courses_business_plus_summary({
            filter: {
              ...this.request,
              sort_name     : this.table.content.pagination.sortBy || null,
              sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
            },
            page      : this.table.content.pagination.page,
            perPage   : this.table.content.pagination.rowsPerPage,
            makeExport: false,
            business_plus: this.table.content.business_plus,
          });
        } else if (this.tab === 'courses_verification') {
          this.SET_COURSES_VERIFICATION_PAGE($event);
          return this.get_courses_verification({
            filter: {
              ...this.request,
              sort_name     : this.table.content.pagination.sortBy || null,
              sort_direction: this.table.content.pagination.descending ? 'desc' : 'asc',
            },
            page      : this.table.content.pagination.page,
            perPage   : this.table.content.pagination.rowsPerPage,
            makeExport: false,
          });
        }
      },
    },
  },
};
</script>

